#import "../../../graphql/fragments/inbox-channel-fragment.graphql"

query GetRelatedTextables($entityId: ID!) {
    relatedTextables(entityId: $entityId) {
        id
        name
        initials
        avatarUrl
        htmlUrlPath
        phones {
            all {
                id
                name
                isFormer
                value {
                    id
                    numberFormatted
                    channel {
                        ...InboxChannelFragment
                    }
                }
            }
        }
    }
}
